<template>
  <div class="box">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'box'
}
</script>



// WEBPACK FOOTER //
// Box.vue?f1186cf0